/**
 * The served receiving-office name (`profile.portalName`) as it reads mid-sentence. Office names
 * ("Secretary of State", "Circuit Clerk") take the definite article; an acronym ("NCSBE") reads as-is,
 * which keeps North Carolina's existing copy byte-identical.
 */
export function receivingOfficePhrase(officeName: string): string {
  return /^[A-Z0-9]+$/.test(officeName) ? officeName : `the ${officeName}`;
}

/** Fill every `{office}` token in a copy template with the receiving-office phrase. */
export function withReceivingOffice(copy: string, officeName: string): string {
  return copy.split('{office}').join(receivingOfficePhrase(officeName));
}
